export const QrPageTranslatedTextsJson = {
  en: {
    loading: "Loading...",
    totalAmount: "Total Amount",
    scanQr: "Scan Code QR",
    or: "OR",
    copyCode: "Copy our payment code",
    availableTime: "Available time",
    verifyingStatusText: "Checking status...",
    verifyingRemainingTimeText: "We are verifying payment status. Please wait.",
  },
  es: {
    loading: "Cargando...",
    totalAmount: "Valor Total",
    scanQr: "Escanear Código QR",
    or: "O",
    copyCode: "Copiar nuestro código de pago",
    availableTime: "Tiempo disponible",
    verifyingStatusText: "Consultando estado...",
    verifyingRemainingTimeText: "Estamos verificando el estado del pago. Por favor aguarde.",
  },
  pt: {
    loading: "Carregando...",
    totalAmount: "Valor Total",
    scanQr: "Escanear Código QR",
    or: "OU",
    copyCode: "Copiar nosso código de pagamento",
    availableTime: "Tempo disponível",
    verifyingStatusText: "Verificando o status...",
    verifyingRemainingTimeText: "Estamos verificando o status do pagamento. Por favor aguarde.",
  },
};
